import React from 'react';
import { Table, Popconfirm, Button, message } from 'antd';
import ExportUtil from '../../common/ExportUtil';
import API_URL from '../../common/url';
import TableC from '../basicElement/TableC';
import $ from '../../common/AjaxRequest';
import Sider from './PlanSider';
import DegreeSetting from './DegreeSetting';
import SortList from '../common/SortList';
import DegreeAdd from './DegreeAdd';
import DegreeChart from './DegreeChart';
import moment from 'moment';

const dateFormat = 'YYYY-MM-DD';

class Degree extends React.Component {
    state = {
        loading: false,
        dataList: [],
        selectedRowKeys: [],
        reRender:true
    }

    componentDidMount() {
        this.loadData();
        this.queryDegreeChoose();
        this.queryInvestigationStageByInvId();
    }

    loadData = () => {
        this.setState({ loading: true });
        const options = {
            url: `${API_URL.plan.degreeList}`,
            data: {},
            dataType: 'json',
            doneResult: (data => {
                this.setState({
                    loading: false,
                    dataList: data.data.degreeList,
                });
            }),
        };
        $.sendRequest(options);
    }

    queryDegreeChoose = () => {
        const options = {
            url: `${API_URL.plan.queryDegreeChoose}`,
            data: {},
            dataType: 'json',
            doneResult: (res => {
                console.log(res);
                const { list = [] } = res || {};
                const  selectedRowKeys =[];
                (list || []).forEach(item=>{selectedRowKeys.push(item.investigationDegreeId)})
                this.setState({
                    selectedRowKeys
                });
            }),
        };
        $.sendRequest(options);
    }

    del = id => {
        const options = {
            url: `${API_URL.plan.deleteDegree}`,
            data: {
                invDegreeId: id,
            },
            dataType: 'json',
            doneResult: (data => {
                this.loadData();
            }),
        };
        $.sendRequest(options);
    }

    queryInvestigationStageByInvId = () => {
        const { invId: investigationId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    invStageList: data,
                });
            },
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            } else if (i.operation === 'BUSINESS_DATA_ARCHIVING') {
                message.error('项目到达“业务数据归档”阶段，不可编辑项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }

    getColumns = () => {
        const { curRole,invStatus, investigationSiteName } = sessionStorage;
        const showOperator = curRole == 'PA' || curRole == 'PM' || (!investigationSiteName && curRole == 'CTA');
        const disabled = invStatus == 'COMPLETED';
        const columns = [
            {
                title: '项目阶段',
                dataIndex: 'stageName',
                key: 'stageName',
            }, {
                title: '计划开始时间',
                dataIndex: 'beginTimePlanStr',
                key: 'beginTimePlanStr',
            }
        ];
        if (investigationSiteName) {
            columns.push({
                title: '实际开始时间',
                dataIndex: 'beginTimeStr',
                key: 'beginTimeStr',
            })  
        }
        columns.push({
            title: '计划结束时间',
            dataIndex: 'endTimePlanStr',
            key: 'endTimePlanStr',
        })  
        if (investigationSiteName) {
            columns.push({
                title: '实际结束时间',
                dataIndex: 'endTimeStr',
                key: 'endTimeStr',
            })  
        }
        if (showOperator) {
            columns.push({
                title: '操作',
                key: 'operation',
                width: 100,
                render: (text, record) => {
                    let delDisabled = false;
                    if (record.beginTimePlan || record.beginTime || record.endTime || record.endTimePlan) {
                        delDisabled = true;
                    }
                    console.log(record.canEdit);
                    return (
                            !investigationSiteName ?
                                <span>
                                    { record.canEdit ? <span><a disabled={disabled} onClick={() => this.canEditByInvStatus(() => this.edit(record))}>设置</a><span className="ant-divider" /></span> : ''}
                                    {
                                        ((!disabled && !delDisabled) || record.defaultSiteNode) ?
                                            <Popconfirm title={'确定要删除吗?'} onConfirm={() => this.del(record.investigationDegreeId)} okText="确定" cancelText="取消">
                                                <a>删除</a>
                                            </Popconfirm>
                                        :
                                            <a disabled>删除</a>
                                    }
                                </span>
                            :
                            (record.canEdit ? <a onClick={() => this.canEditByInvStatus(() => this.edit(record))}>调整</a> :'-')
                    );
                },
            });
        }
        return columns;
    }

    getDataSource = () => {
        const resList = [];
        const { dataList } = this.state;
        dataList.map((degree, i) => {
            resList.push({
                investigationDegreeId: degree.investigationDegreeId,
                stageName: degree.stageName,
                beginTimePlan: this.getDateShowValue(degree.beginTimePlan),
                beginTime: this.getDateShowValue(degree.beginTime),
                endTimePlan: this.getDateShowValue(degree.endTimePlan),
                endTime: this.getDateShowValue(degree.endTime),
                ...degree,
            });
        });
        return resList;
    }

    edit = record => {
        this.degreeSettingRef.show(record);
    }

    getDateShowValue = value => {
        if (value != null) {
            return moment(value).format(dateFormat);
        }
        return null;
    }

    sort = () => {
        const sortList = [];
        const { dataList } = this.state;
        dataList.map(item => {
            sortList.push({
                key: item.investigationDegreeId,
                name: item.stageName,
            });
        });
        this.degreeSortRef.show(sortList);
    }

    add = () => {
        this.degreeAddRef.show();
    }

    showChart = () => {
        this.degreeChartRef.show();
    }

    onSelectChange = (record, selected) => {
        const { investigationDegreeId } = record;
        let list = [...this.state.selectedRowKeys];
        if (selected) {
            list.push(investigationDegreeId);
        } else {
            list = list.filter(i => i != investigationDegreeId);
        }
        this.setState({ selectedRowKeys: list },()=>this.saveDegreeChoose());
    }

    onSelectAllChange = (selected, selectedRows, changeRows) => {
        let hasEmpty = false;
        let list = [...this.state.selectedRowKeys];
        if (selected) {
            changeRows.forEach(i => {
                if (!i.userId) {
                    hasEmpty = true;
                    list.push(i.investigationDegreeId);
                }
            });
        }
        if (!selected || !hasEmpty) {
            list = [];
        }
        this.setState({ selectedRowKeys: list },()=>this.saveDegreeChoose());
    }

    handleSelectChange = (value) => {
        this.setState({ userId: value });
    }
    
    getCheckboxProps = (record) => {
        const { userId: baId } = record;
        const { userId } = sessionStorage;
        return {
            disabled: false
        };
    }
    
    saveDegreeChoose = ()=>{
        const { selectedRowKeys=[] } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.plan.saveDegreeChoose,
            data: { degreeIds:selectedRowKeys.join(',') },
            dataType: 'json',
            doneResult: res => {
              
            },
        };
        $.sendRequest(options);
    }

    export = () => {
        const { invId, invState } = sessionStorage;
        const type = invState == 3 ? 'configure' : 'site';
        ExportUtil.export({ curInvId: invId, type}, null, API_URL.export.exportInvestigationDegree);
    }

    reRender = () => {
        this.setState({
          reRender: false,
        }, () => {
          this.setState({
            reRender: true,
          });
        });
      }

    render() {
        const { loading,selectedRowKeys, reRender } = this.state;
        const { curRole, invStatus, investigationSiteName } = sessionStorage;
        const disabled = invStatus == 'COMPLETED';
        const rowSelection = {
            selectedRowKeys,
            onSelect: this.onSelectChange,
            onSelectAll: this.onSelectAllChange,
            getCheckboxProps: this.getCheckboxProps,
        };
        return (
            <div className="content">
                <Sider selectKey="degree" />
                <div className="main">
                    <div className="breadcrumb-bar tac">
                        <h2 className="title">项目阶段进度计划</h2>
                    </div>
                    {
                        !investigationSiteName && (curRole == 'PA' || curRole == 'PM' || curRole == 'CTA') &&
                        <div className="filter-bar tar">
                            <Button disabled={disabled} type="primary" onClick={this.sort}>排序调整</Button>
                            <Button disabled={disabled} type="primary" onClick={this.export}>导出</Button>
                            <Button disabled={disabled} type="primary" onClick={this.add}>添加</Button>
                        </div>
                    }
                    {
                        investigationSiteName &&
                        <div className="filter-bar tar">
                            <Button type="primary" onClick={this.showChart}>甘特图</Button>
                            <Button disabled={disabled} type="primary" onClick={this.export}>导出</Button>
                        </div>
                    }
                    <div className="main-content degree">
                        {/* <Table
                            columns={this.getColumns()}
                            dataSource={this.getDataSource()}
                            rowKey={record => record.investigationDegreeId}
                            loading={loading}
                            pagination={false}
                        /> */}
                        <TableC
                        loading={loading}
                        rowKey="investigationDegreeId"
                        pagination={false}
                        columns={this.getColumns()}
                        data={this.getDataSource()}
                        rowSelection={rowSelection}
                        //onChange={this.handleTableChange}
                    />
                    </div>
                </div>
                <DegreeSetting ref={el => { this.degreeSettingRef = el; }}
                    reload={this.loadData}
                />
                <SortList ref={el => { this.degreeSortRef = el; }}
                    reload={this.loadData}
                    sortUrl={`${API_URL.plan.sortDegree}`}
                    title='项目阶段-调整（排序）'
                />
                {
                    reRender && <DegreeAdd ref={el => { this.degreeAddRef = el; }}
                     reload={this.loadData}
                     reRender={this.reRender}
                    />
                }
                
                <DegreeChart selectedRowKeys={ selectedRowKeys }  ref={el => { this.degreeChartRef = el; }}
                />
            </div>
        );
    }
}

export default Degree;


// WEBPACK FOOTER //
// ./src/components/plan/Degree.js